import { WorkshopEntity, WorkshopSection } from "./workshops.entities";
import { plainToClass } from "class-transformer";

export class WorkshopsPage {
    workshops: WorkshopEntity[];

    constructor(workshops: any[], targetFile: string = "", targetSearchBox: string = "") {
        this.workshops = plainToClass(WorkshopEntity, <WorkshopEntity[]>workshops);

        this.workshops.forEach(workshop => {
            let workshopSection = new WorkshopSection(workshop, targetFile, targetSearchBox);
        })
    }
}

